package one.healthium.insights.ui.components.items

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.relocation.bringIntoViewRequester
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import one.healthium.insights.domain.models.ActionModel
import one.healthium.insights.domain.models.ContentEntry
import one.healthium.insights.ui.components.AnchorState
import one.healthium.insights.ui.components.ContentEntryItem

@Composable
fun ContentAnchor(
    modifier: Modifier = Modifier,
    entry: ContentEntry.Anchor,
    anchorState: AnchorState,
    onActionClicked: (ActionModel) -> Unit,
    isMetrics: Boolean,
    actionButton: String? = null,
    onTextActionClicked: () -> Unit = {},
) {
    Box(
        modifier = modifier.bringIntoViewRequester(anchorState.getOrCreateBringIntoViewRequester(entry.anchorId))
    ) {
        ContentEntryItem(
            entry = entry.content,
            anchorState = anchorState,
            onActionClicked = onActionClicked,
            actionButton = actionButton,
            onTextActionClicked = onTextActionClicked,
            isMetrics = isMetrics,
        )
    }
}